import { unauthenticatedFetch } from "../../api/request";

export default async function verifyForgotPasswordSecret(secret: string) {
    const url = '/public/v5/users/account/verifyForgotPasswordSecret';
    return await unauthenticatedFetch(url, {
        method: 'POST',
        body: JSON.stringify({ forgot_password_secret: secret }),
    });
}
